import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const searchFilterReducer = (state, action) => {
  const {
    newValues,
    type,
    shouldSearch = true
  } = action;
  switch (type) {
    case 'update':
      return _objectSpread(_objectSpread(_objectSpread({}, state), newValues), {}, {
        shouldSearch
      });
    case 'resetSearch':
      return _objectSpread(_objectSpread({}, state), {}, {
        shouldSearch: false
      });
    case 'reset':
      return null;
    default:
      throw new Error();
  }
};
export default searchFilterReducer;
//# sourceMappingURL=searchFilterReducer.js.map